import { z } from 'zod';

import { Box, Form } from '@ekhodealer/ekho-common/rev';

const shippingFeesSchema = z.object({
	enabled: z.boolean().optional(),
});

export function ShippingFeesSection() {
	return (
		<Box padding='24' background='secondary' rounding='12'>
			<div data-settings-disabled>
				<Form
					name='ai-bdc-shipping-fees'
					schema={shippingFeesSchema}
					defaultValues={{ enabled: false }}
					onSubmit={async () => ({ isSuccess: false })}
					title='Shipping fees'
					titleLevel='subgroup'
					titleWeight='semibold'
					titleMaxWidth='full'
					description="Allow the AI to estimate shipping and delivery costs based on a buyer's location and the vehicle they're interested in."
					tag={{ children: 'Coming soon', size: 'small' }}
					toggle={{ fieldName: 'enabled' }}>
					{null}
				</Form>
			</div>
		</Box>
	);
}
